import type { HoleEntryInput } from "../../domain/round/round-types.js";

/** The stored revision is server-owned, not part of a new scoring command. */
export function holeEntryInput(entry: HoleEntryInput): HoleEntryInput {
  return {
    status: entry.status,
    strokes: entry.strokes,
    putts: entry.putts,
    fairwayHit: entry.fairwayHit,
    greenInRegulation: entry.greenInRegulation,
    source: entry.source,
  };
}
